import React from 'react'
import { Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../../shared/CustomButton';

const ForgotPasswordForm = ({
    isSaving,
    formAction,
    onBack
}) => {
    const {
        register,
        handleSubmit,
        setError,
        resetField,
        formState: {errors}
    } = useForm();

    const onSubmit = async (data) => {
        try {
            const success = await formAction(data);
        } catch (error){
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error to be handled by forgotPassword in ForgotPassword.jsx
            }
        }
    }
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Form.Group>

            <Form.Label htmlFor='email'>Email Address</Form.Label>
            <input type='email' placeholder='Email Address' autoFocus autoComplete='off'
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                {...register('email', {
                    required: 'Enter your email address',
                    pattern: {
                        value: /^[A-z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Email address is not valid'
                    }
                })}
            />
            {errors.email && (
                <div className="invalid-feedback">{errors.email.message}</div>
            )}

        </Form.Group>

        <CustomButton
            title={isSaving ? 'Requesting Password Reset' : 'Request Password Reset'}
            isSaving={isSaving}
        />

    </Form>
  )
}

export default ForgotPasswordForm